<template>
  <dialog modal class="fixed inset-0 z-50 w-full h-full group bg-transparent"
    :class="[modalContentPoisition, modal.type]" :open="modal.isOpen || $slots.default">
    <div :class="modal.type == 'add-product' && isMobile ? 'hidden md:block' : ''"
      class="fixed inset-0 bg-black/50 cursor-pointer transition-all duration-500 ease-in-out w-full h-full backdrop-blur-xs animation"
      @click="close(false)" />
    <div
      class="relative animation h-full w-full md:flex md:items-center md:justify-center block cursor-pointer [&>div]:first:cursor-auto"
      :class="centerModal()" @click="close(false)">
      <transition-group :name="modal.animation.name" @after-enter="showCloseButton">
        <add-product @click.stop v-if="modal.type == 'add-product'" v-bind="modal.context"
          class="h-full w-full lg:h-fit min-h-[65%] md:w-[90%] lg:w-[80%] md:max-h-[90vh] max-w-(--breakpoint-lg)" />
        <change-order-method @click.stop v-else-if="modal.type == 'change-order-method'"
          :product="modal.context.product" :isModal="true"
          class="bg-background md:rounded-lg h-full w-full md:min-h-[500px] md:h-fit md:max-h-[90vh] md:w-[90%] lg:w-[70%] xl:w-[50%]" />
        <notification-summary @click.stop v-else-if="modal.type == 'notification-summary'"
          class="h-[100vh] w-full lg:w-[28vw] absolute right-0" />
        <promotions @click.stop v-else-if="modal.type == 'promotions'"
          class="h-full lg:max-h-[80vh] w-full md:w-[65vw] xl:w-[50vw]"></promotions>
        <pos-info @click.stop v-else-if="modal.type == 'pos-info'"
          class="w-full h-full lg:h-min lg:max-h-[90vh]  lg:w-[40vw]" />
        <cart @click.stop v-else-if="modal.type == 'cart'" class="h-full w-full lg:w-[40vw] bg-background mt-0">
          <template #header>
            <div class="flex flex-row justify-between px-4 py-2 mt-5">
              <button @click="modal.close(false)">
                <PhX class="h-6! w-6! stroke stroke-black stroke-10" />
              </button>
              <h5 class="text-black! font-bold">{{ $t('cart') }}</h5>
              <button v-if="!isClearing" @click="clearCart" class="">
                <PhTrash weight="duotone" class="h-6! w-6! text-red-600 fill-red-600" />
              </button>
              <loader v-else size="s" :message="false"></loader>
            </div>
          </template>
          <template #footer="{ proceedToCheckout, disabled }">
            <button @click="proceedToCheckout" :disabled="disabled"
              class="btn btn-primary absolute bottom-5 left-4 right-4 flex! flex-row items-center justify-center gap-x-2 font-bold mt-auto disabled:cursor-none disabled:opacity-25"
              v-wave>
              <span class="text-white">{{ $t('order_proceed') }}</span>
              <PhCaretDoubleRight class="h-4! w-4! stroke-12 fill-white stroke-white" />
            </button>
          </template>
        </cart>
        <alert @click.stop v-else-if="modal.type == 'alert'" class="w-[90vw] lg:w-[40vw] max-h-fit"
          v-bind="modal.context" />
        <LoyaltyAlert v-else-if="modal.type == 'loyalty-alert'" @click.stop class="w-[90vw] lg:w-[40vw] max-h-fit" />
        <delete-account @click.stop v-else-if="modal.type == 'delete-account'" class="w-[90vw] lg:w-[40vw] max-h-fit" />
        <restaurant-details @click.stop v-else-if="modal.type == 'restaurant-details'" is-modal :id="modal.context.id"
          class="bg-white lg:max-h-fit md:rounded-lg" />
      </transition-group>
    </div>
  </dialog>
</template>

<script setup>
import { computed, onMounted, onUnmounted, defineAsyncComponent, defineEmits } from "vue";
import { useScreen } from "../composables/screen";

const Loader = defineAsyncComponent(() => import("@/components/Loader.vue"));
const AddProduct = defineAsyncComponent(() => import("@/components/modals/AddProduct.vue"));
const DeleteAccount = defineAsyncComponent(() => import("@/components/modals/DeleteAccount.vue"));
const Alert = defineAsyncComponent(() => import("@/components/modals/Alert.vue"));
const NotificationSummary = defineAsyncComponent(() => import("@/components/NotificationSummary.vue"));
const Promotions = defineAsyncComponent(() => import("@/components/Promotions.vue"));
const PosInfo = defineAsyncComponent(() => import("@/components/PosInfo.vue"));
const ChangeOrderMethod = defineAsyncComponent(() => import("@/views/OrderType.vue"));
const Cart = defineAsyncComponent(() => import("@/components/Cart.vue"));
const RestaurantDetails = defineAsyncComponent(() => import("@/components/RestaurantDetails.vue"));
const LoyaltyAlert = defineAsyncComponent(() => import("@/components/modals/LoyaltyAlert.vue"));
import { PhX, PhTrash, PhCaretDoubleRight } from "@phosphor-icons/vue";

const emit = defineEmits(['close']);
import { useStoreModal } from "@/stores/modal";
let modal = useStoreModal();

let { isMobile, isTablet } = useScreen();

onMounted(() => {
  window.addEventListener('keydown', escapeClickHanlder);
});

function escapeClickHanlder(e) {
  if (e.key === 'Escape') close(false);
}

onUnmounted(() => {
  window.removeEventListener('keydown', escapeClickHanlder);
});

const modalContentPoisition = computed(() => {
  if (['slide', 'fade'].includes(modal.animation.name)) return 'flex items-center justify-center h-full w-full';
  return '';
});

function showCloseButton() {
  if (['notification-summary', 'cart', 'add-product', 'restaurant-details'].includes(type)) return;
  modal.toggleCloseButton(true);
}

function centerModal() {
  if (['alert', 'delete-account', 'loyalty-alert'].includes(modal.type)) return 'flex items-center justify-center';
}

const type = computed(() => modal.value.type);

const close = () => {
  modal.close(false);
  modal.toggleCloseButton(false);
  emit('close', false);
};
</script>
